import { useState, useRef, useEffect } from 'react';
import { Divider } from '@mui/material';

import {
  TestimonialBoldText,
  TestimonialContent,
  TestimonialText,
  TestimonialTextContainer,
  TestimonialTextScrollable,
  TestimonialAuthorInfo,
  TestimonialAuthorSection,
  AuthorName,
  AuthorCredentials,
  AuthorAvatar,
} from './styles';

import { getInitials } from '../../../../../../../ui/utils';

const TestimonyCard = ({ item, isActive }) => {
  const [showGradient, setShowGradient] = useState(true);
  const [imageError, setImageError] = useState(false);
  const scrollableRef = useRef(null);

  const handleScroll = () => {
    const element = scrollableRef.current;
    if (element) {
      const isAtBottom = element.scrollHeight - element.scrollTop <= element.clientHeight + 5;
      setShowGradient(!isAtBottom);
    }
  };

  useEffect(() => {
    const element = scrollableRef.current;
    if (element) {
      const hasOverflow = element.scrollHeight > element.clientHeight;
      setShowGradient(hasOverflow);
    }
  }, [item.text, item.boldText]);

  return (
    <TestimonialContent isActive={isActive}>
      <TestimonialAuthorSection top>
        <TestimonialAuthorInfo>
          <div>
            <AuthorName>{item.name}</AuthorName>
            <AuthorCredentials>Review Author</AuthorCredentials>
          </div>
        </TestimonialAuthorInfo>
      </TestimonialAuthorSection>
      <TestimonialTextContainer showGradient={showGradient}>
        <TestimonialTextScrollable ref={scrollableRef} onScroll={handleScroll}>
          <TestimonialText>{item.text}</TestimonialText>
          <TestimonialBoldText>{item.boldText}</TestimonialBoldText>
        </TestimonialTextScrollable>
      </TestimonialTextContainer>
      <Divider sx={{ marginTop: 'auto', width: '100%', border: '1px solid #EAE6DA' }} />
      <TestimonialAuthorSection>
        <TestimonialAuthorInfo>
          <AuthorAvatar
            src={imageError ? undefined : item.avatar}
            alt={item.name}
            onError={() => setImageError(true)}
            sx={{ width: 75, height: 75 }}
            backgroundColor={item.backgroundColor}
          >
            {imageError ? getInitials(item.name) : null}
          </AuthorAvatar>
          <div>
            <AuthorName>{item.practitionerName}</AuthorName>
            <AuthorCredentials>Practitioner</AuthorCredentials>
          </div>
        </TestimonialAuthorInfo>
      </TestimonialAuthorSection>
    </TestimonialContent>
  );
};

export default TestimonyCard;
